var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandMenuDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.545 38.48C29.6487 37.462 29.2041 36.1966 29.2041 34.6909C29.2041 34.0334 29.2818 33.2841 29.437 32.457C29.5923 31.6229 29.7617 30.817 29.931 30.0323C30.1004 29.2476 30.2204 28.7457 30.2839 28.5266C30.5309 27.4308 30.7708 26.3493 30.9896 25.2818C31.2084 24.2144 31.3213 23.3519 31.3213 22.6945C31.3213 21.0969 30.7567 20.291 29.6276 20.291C28.8089 20.291 28.0891 20.6939 27.468 21.4927C26.84 22.2916 26.3389 23.3378 25.9649 24.6244L22.7679 39.7383H16L20.9824 16.1909H27.7503L27.2352 18.6368C28.8019 16.8766 30.6368 16 32.7328 16C34.3277 16 35.598 16.4383 36.5366 17.3149C37.4752 18.1914 37.9481 19.5275 37.9481 21.316C37.9481 22.2279 37.8352 23.2388 37.6164 24.3487C37.3976 25.4656 37.08 26.8229 36.6778 28.4205C36.4237 29.3961 36.1979 30.3433 35.9932 31.2694C35.7886 32.1955 35.6898 32.9236 35.6898 33.4608C35.6898 34.09 35.8309 34.5778 36.1132 34.9171C36.3955 35.2635 36.8824 35.4331 37.567 35.4331C38.5056 35.4331 39.2607 35.0938 39.8253 34.4223C40.3899 33.7507 40.9545 32.7044 41.5191 31.2906H43.4951C42.3377 34.7404 40.9968 37.0591 39.4795 38.2325C37.9622 39.406 36.3884 39.9998 34.7582 39.9998C32.8457 39.9998 31.4483 39.4908 30.5521 38.4729L30.545 38.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6028 43.6423C50.4251 41.0912 53.4058 40 56.4359 40C59.466 40 64.0005 40.8672 64.0005 49.4742V63.9998H57.234V50.6088C57.234 48.3324 57.0151 44.6468 53.4058 44.6468C48.956 44.6468 48.8642 49.9728 48.8642 50.9773V63.9998H42.0977V40.8672H48.5958V43.6423H48.6028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandMenuDefault);
export default __webpack_public_path__ + "static/media/brandMenuDefault.dd3bba0a903bffc3d90f78d4668fbb1f.svg";
export { ForwardRef as ReactComponent };